import { createContext } from 'react';
import * as T from './types';

const dependencyManagerContext = createContext(
  {} as T.DependencyManagerContextType
);

export default dependencyManagerContext;
